import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useDistributorMovements = (distributorId, page = 1, filters = {}) => useQuery({
    queryKey: ['distributor-movements', distributorId, page, filters],
    queryFn: async () => {
        if (!distributorId) return null
        const params = new URLSearchParams({ page, ...Object.fromEntries(Object.entries(filters).filter(([, v]) => v)) })
        const { data } = await API.get(`/distributors/${distributorId}/stock/movements?${params}`)
        return data
    },
    enabled: !!distributorId
})

export default useDistributorMovements
